import { Form, Button, Icon, notification, Card, Tooltip } from "antd";
import React, { Component } from "react";
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import Request, { LAPI_URL } from "../../../request";
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

@Form.create()
class LeadSetup extends Component {
    state = {
        loading: false,
        studentPaymentOptions: false,
        paymentOptions: [],
        paymentMethods: [],
        cardLoading: false,
    }


    onPrev = () => {
        this.props.onPrev();
    }


    handleFormSubmit = (e) => {
        e.preventDefault();
        let { form, onNext, isModal } = this.props;
        form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                values.businessId = activeUser.businessId;
                values.paymentOptions = this.state.paymentOptions;
                values.paymentMethods = this.state.paymentMethods;
                this.setState({ loading: true });
                let response = await Request.addUpdateCompanySetting(values);
                this.setState({ loading: false });
                if (response && response.success) {
                    notification.success({
                        message: response.message
                    })
                    if (isModal) {
                        onNext();
                    }
                } else {
                    notification.error({
                        message: response.message
                    })
                }
            }
        })

    }

    loadInitialData = async () => {
        this.setState({ cardLoading: true });
        let res = await Request.getBusinessDetails(activeUser.businessId);
        this.setState({ cardLoading: false });
        if (res) {
            this.props.form.setFieldsValue(res);

            let paymentOptions = res.paymentOptions ? res.paymentOptions : [];

            this.setState({
                companySettingObject: res,
                studentPaymentOptions: res.studentPaymentOptions || false,
                paymentOptions: paymentOptions,
                paymentMethods: res.paymentMethods || []
            });

            // ✅ Sync switches based on paymentOptions
            this.props.form.setFieldsValue({
                studentPaymentConsultancyCharges: paymentOptions.includes('Consultancy Charges'),
                studentPaymentPayAfterVisa: paymentOptions.includes('Pay After Visa')
            });
        }

    }


    componentDidMount() {
        this.loadInitialData()
    }

    render() {
        const withTooltip = (label, message) => (
            <span>
                {label}
                <Tooltip title={message}>
                    <Icon type="question-circle" style={{ marginLeft: 6, color: '#1890ff' }} />
                </Tooltip>
            </span>
        );
        let { form: { setFieldsValue, getFieldDecorator }, isModal } = this.props;
        let { loading, studentPaymentOptions, cardLoading } = this.state;
        // let inputTypes = {
        //     fields: [
        //         {
        //             label: 'Student Payment Options',
        //             key: 'studentPaymentOptions',
        //             type: 'switch',
        //             onChange: v => {
        //                 setFieldsValue({ studentPaymentOptions: v });
        //                 this.setState({ studentPaymentOptions: v });
        //             }
        //         },
        //         {
        //             label: 'Consultancy Charges',
        //             key: 'studentPaymentConsultancyCharges',
        //             type: 'switch',
        //             hidden: !studentPaymentOptions,
        //             onChange: v => {
        //                 setFieldsValue({ studentPaymentConsultancyCharges: v });
        //                 let currentOptions = [...this.state.paymentOptions];
        //                 if (v) {
        //                     if (!currentOptions.includes('Consultancy Charges')) currentOptions.push('Consultancy Charges');
        //                 } else {
        //                     currentOptions = currentOptions.filter(x => x !== 'Consultancy Charges');
        //                 }
        //                 this.setState({ paymentOptions: currentOptions });
        //             }
        //         },
        //         {
        //             label: 'Pay After Visa',
        //             key: 'studentPaymentPayAfterVisa',
        //             type: 'switch',
        //             hidden: !studentPaymentOptions,
        //             onChange: v => {
        //                 setFieldsValue({ studentPaymentPayAfterVisa: v });
        //                 let currentOptions = [...this.state.paymentOptions];
        //                 if (v) {
        //                     if (!currentOptions.includes('Pay After Visa')) currentOptions.push('Pay After Visa');
        //                 } else {
        //                     currentOptions = currentOptions.filter(x => x !== 'Pay After Visa');
        //                 }
        //                 this.setState({ paymentOptions: currentOptions });
        //             }
        //         },
        //         { label: 'Account Payment', key: 'addInAccountPayment', type: 'switch', onChange: v => setFieldsValue({ addInAccountPayment: v }) },
        //         { label: 'Refund Visa Fee', key: 'refundVisaFee', type: 'switch', onChange: v => setFieldsValue({ refundVisaFee: v }) },
        //         { label: 'University Expiry Emails', key: 'universityExpireNotification', type: 'textarea' }
        //     ]
        // }
        let inputTypes = {
            fields: [
                {
                    label: withTooltip('Student Payment Options', 'Enable to configure different payment options for students.'),
                    key: 'studentPaymentOptions',
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({ studentPaymentOptions: v });
                        this.setState({ studentPaymentOptions: v });
                    }
                },

                {
                    label: withTooltip('Consultancy Charges', 'Enable to allow charging consultancy fees from students.'),
                    key: 'studentPaymentConsultancyCharges',
                    type: 'switch',
                    hidden: !studentPaymentOptions,
                    onChange: v => {
                        setFieldsValue({ studentPaymentConsultancyCharges: v });
                        let currentOptions = [...this.state.paymentOptions];
                        if (v) {
                            if (!currentOptions.includes('Consultancy Charges')) currentOptions.push('Consultancy Charges');
                        } else {
                            currentOptions = currentOptions.filter(x => x !== 'Consultancy Charges');
                        }
                        this.setState({ paymentOptions: currentOptions });
                    }
                },

                {
                    label: withTooltip('Pay After Visa', 'Allow students to pay fees after visa approval.'),
                    key: 'studentPaymentPayAfterVisa',
                    type: 'switch',
                    hidden: !studentPaymentOptions,
                    onChange: v => {
                        setFieldsValue({ studentPaymentPayAfterVisa: v });
                        let currentOptions = [...this.state.paymentOptions];
                        if (v) {
                            if (!currentOptions.includes('Pay After Visa')) currentOptions.push('Pay After Visa');
                        } else {
                            currentOptions = currentOptions.filter(x => x !== 'Pay After Visa');
                        }
                        this.setState({ paymentOptions: currentOptions });
                    }
                },

                // {
                //     label: withTooltip('Account Payment', 'Automatically add student payments into their account balance.'),
                //     key: 'addInAccountPayment',
                //     type: 'switch',
                //     onChange: v => setFieldsValue({ addInAccountPayment: v })
                // },

                {
                    label: withTooltip('Refund Visa Fee', 'Enable refund of consultancy fee to students when applicable.'),
                    key: 'refundVisaFee',
                    type: 'switch',
                    onChange: v => setFieldsValue({ refundVisaFee: v })
                },

                // {
                //     label: withTooltip('University Expiry Emails', 'Send alerts when university offers or deadlines are about to expire.'),
                //     key: 'universityExpireNotification',
                //     type: 'textarea'
                // }
            ]
        };
        return (
            <Card loading={cardLoading}>
                <Form onSubmit={(e) => this.handleFormSubmit(e)}>
                    <GetAllFormFields apiurl={LAPI_URL} inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} />
                    <div style={{ marginTop: 30, textAlign: 'right', borderTop: '1px solid #f0f0f0', paddingTop: '20px' }}>
                        {isModal && <Button onClick={this.onPrev} style={{ height: 40, width: 100, marginRight: 10 }}>BACK</Button>}

                        <Button type="primary" htmlType="submit" loading={loading} style={{ height: 40, width: 140 }}>{isModal ? <span> NEXT STEP <Icon type="arrow-right" /></span> : 'SAVE'}</Button>
                    </div>
                </Form>
            </Card>
        )

    }
}



export default LeadSetup;